import { AlertTriangle } from "react-feather";
import { ShadowBox } from "../../UI/ShadowBox/ShadowBox";
import { Bullets } from "../../ContributeForm/Bullets/Bullets";
import { PearlsIcon } from "../../../assets/icons/PearlsIcon";
import styles from "./PearlsAndPitfalls.module.scss";

export const PearlsAndPitfalls = ({ title, slug }) => (
  <ShadowBox className={styles.root}>
    <div className={styles.titleContainer}>
      <div className={styles.iconContainer}>
        {slug === "pearls" ? (
          <PearlsIcon />
        ) : (
          <AlertTriangle size={32} />
        )}
      </div>
      <h2>{title}</h2>
    </div>
    <Bullets text="Add list" slug={`${slug}.bullets`} />
  </ShadowBox>
);
